export default __webpack_public_path__ + "static/media/thunder.22d2728e.jpg";